"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function TheMindBehindApex() {
  const {
    ref: imageRef,
    isVisible: imageVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  const {
    ref: contentRef,
    isVisible: contentVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.2
  });
  return <section data-section-id="2360" id="the-mind-behind-apex" className="bg-background text-foreground relative w-full min-h-screen overflow-hidden">
      <div className="grid grid-cols-1 lg:grid-cols-[45fr_55fr] min-h-screen">
        {}
        <div ref={imageRef} className={`relative w-full h-[60vh] lg:h-auto lg:min-h-screen overflow-hidden transition-all duration-[1400ms] ease-out ${imageVisible ? "opacity-100 translate-x-0" : "opacity-0 -translate-x-8"}`}>
          <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1700728/img/apex_tutor_workspace.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1700728/img/apex_tutor_workspace.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1700728/img/apex_tutor_workspace.png-wvc-sizes" alt="ApexTutor workspace with digital tablet and complex STEM equations" loading="lazy" decoding="async" className="absolute inset-0 w-full h-full object-cover" />
          <div className="absolute inset-0 bg-gradient-to-t from-background/40 via-transparent to-transparent pointer-events-none" />
        </div>

        {}
        <div className="relative flex items-center bg-background">
          <div ref={contentRef} className={`w-full px-6 py-16 sm:px-10 md:px-16 lg:pl-24 lg:pr-32 lg:py-24 transition-all duration-[1200ms] ease-out ${contentVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`}>
            {}
            <p className="font-mono uppercase text-[11px] font-medium" style={{
            letterSpacing: "0.3em",
            color: "var(--chart-1)"
          }}>
              Philosophy <span className="mx-2 opacity-60">·</span> Methodology
            </p>

            {}
            <h1 className="font-default text-foreground font-bold mt-16" style={{
            fontSize: "clamp(2.5rem, 6vw, 4.5rem)",
            lineHeight: 1.05,
            letterSpacing: "-0.04em"
          }}>
              Precision in
              <br />
              <span className="italic font-default text-primary">every calculation.</span>
            </h1>

            {}
            <div className="mt-14 max-w-[480px]">
              <p className="font-default text-foreground/90" style={{
              fontSize: "1.125rem",
              lineHeight: 1.6
            }}>
                ApexTutor was founded on the principle that academic mastery is not a matter of chance, but of architecture. After years of navigating the complexities of high-stakes STEM curricula, our founder developed a system that strips away the noise, focusing entirely on the fundamental logic that governs success in Calculus, Physics, and beyond.
              </p>

              <div className="h-8" />

              <p className="font-default text-foreground/90" style={{
              fontSize: "1.125rem",
              lineHeight: 1.6
            }}>
                We treat every student as an engineer of their own potential. By combining rigorous digital whiteboard analysis with personalized test-prep strategies, we ensure that every session builds toward a measurable, high-impact result. We don't just teach subjects; we teach the mechanics of thinking.
              </p>
            </div>

            {}
            <div className="mt-16">
              <div className="mb-3" aria-hidden="true">
                <svg width="56" height="14" viewBox="0 0 56 14" fill="none" xmlns="http://www.w3.org/2000/svg" style={{
                color: "var(--chart-2)"
              }}>
                  <path d="M1 9 C 8 4, 14 12, 22 7 S 38 2, 46 8 C 50 10, 53 9, 55 6" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" fill="none" />
                </svg>
              </div>
              <p className="font-default italic text-foreground" style={{
              fontSize: "16px",
              letterSpacing: "0.01em"
            }}>
                Lead Mentor <span className="not-italic opacity-50 mx-1">·</span>{" "}
                <span className="opacity-80">ApexTutor Founder</span>
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}